<template>
    <a-row class="voice-data" :gutter="20">
      <a-col class="row" :span="10">
        <voice-data-list @selectRow="selectRow"></voice-data-list>
      </a-col>
      <a-col :span="14" class="row">
        <voice-data-patient-list :voiceBatchId="voiceBatchId"></voice-data-patient-list>
      </a-col>
    </a-row>
</template>

<script>
  import VoiceDataList from './voice/VoiceDataList'
  import VoiceDataPatientList from './voice/VoiceDataPatientList'
  export default {
    name: 'VoiceData',
    components: { VoiceDataPatientList, VoiceDataList },
    data(){
      return {
        voiceBatchId:''
      }
    },
    mounted(){},
    methods:{
      selectRow(row){
        this.voiceBatchId = row.voiceBatchId
      }
    }
  }
</script>

<style scoped lang="less">
</style>